function setExternalHelpers(helpers) {
  Object.keys(helpers).forEach((key) => {
    helpers[key];
  });
}
export {
  setExternalHelpers
};
//# sourceMappingURL=externals.es.js.map
